import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed } from 'vue';
import stylesJS from '@/assets/styles.js';


export default /*@__PURE__*/_defineComponent({
  __name: 'listGroup2',
  props: {
  styles: {
    type: String,
    default: ""
  },
  active: {
    type: Boolean,
    default: false
  },
},
  setup(__props) {

const props = __props

const hover = ref(false)

function hoverOn() {
  hover.value = true
}

function hoverOff() {
  hover.value = false
}

const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iBorder = importOBJ.border || "none"
  iBorder = "border-" + iBorder
  let iBg = importOBJ.bg || "0"
  iBg = "bg-" + iBg
  let iPad = importOBJ.pad  || "none"
  iPad = "pad-" + iPad

  // State
  let sShadow  = ''
  if (hover.value) {sShadow = 'shadow-txt'}
  if (props.active) {sShadow = 'bigshadow'}

  return ['component', 'row', 'cursor-action', sShadow, iBg, iPad, iBorder]
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classList.value),
    onMouseover: hoverOn,
    onMouseleave: hoverOff
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 34))
}
}

})